import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";

const FAQS = [
  { q: "What are the stickers made from?", a: "Premium white vinyl with a full-colour print. All stickers are full die-cut to the shape of your design." },
  { q: "What file types can I upload?", a: "PDF, PNG, JPG, JPEG, SVG, AI and EPS files up to 50 MB." },
  { q: "Can you cut custom shapes?", a: "Yes — pick 'Custom Shape' on the Die-Cut Stickers page and we'll cut to your artwork outline." },
  { q: "What quantities can I order?", a: "Enter any quantity you need. Die-cut stickers have a $99 minimum order ($125 for custom shapes) and sticker sheets have a $125 minimum order." },
  { q: "Can I order just 50 stickers?", a: "Yes — enter any quantity. The minimum order charge applies to small runs." },
  { q: "Can I order 100,000+ stickers?", a: "Yes — large production runs are our specialty. Get in touch for pricing above 100,000." },
  { q: "Can you fix my artwork?", a: "If your artwork needs significant redesign, tracing or recreation we charge from $30 artwork setup — we'll always confirm before proceeding." },
  { q: "Do you offer waterproof stickers?", a: "Our vinyl stickers hold up well to typical day-to-day moisture. Contact us if you have a specific durability requirement so we can advise." },
  { q: "Do you offer laminate?", a: "Laminate options are available on request — contact us for a tailored quote." },
  { q: "How long does production take?", a: "Production times vary based on volume. We'll confirm turnaround once your order and artwork are approved." },
  { q: "Do you ship Australia-wide?", a: "Yes — we ship right across Australia. Delivery costs are confirmed after you order, based on weight and destination." },
  { q: "Can I collect my order?", a: "Yes — choose Pickup at checkout and collect from Kwik Kopy Shellharbour." },
];

export default function FAQ() {
  const [query, setQuery] = useState("");
  const filtered = FAQS.filter((f) => f.q.toLowerCase().includes(query.toLowerCase()));
  return (
    <div className="App">
      <Header />
      <section className="max-w-3xl mx-auto px-5 lg:px-8 pt-12 pb-16">
        <div className="eyebrow">FAQ</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black mt-2">Good questions.</h1>
        <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search questions…"
          className="w-full mt-6 px-4 py-3 rounded-full border border-[#E2DDD5] bg-white" data-testid="faq-search"/>
        <Accordion type="single" collapsible className="mt-6">
          {filtered.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#E2DDD5]">
              <AccordionTrigger className="text-left font-semibold" data-testid={`faq-q-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-600" data-testid={`faq-a-${i}`}>{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
      <Footer />
    </div>
  );
}
